module.exports = __webpack_public_path__ + "0af5d249/img/boston-lights.a623432f.png";